import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Dialogs from '../../Dialog/Dialogs'
import Formulario from '../NuevoCliente/Formulario'
import Formulario1 from '../NuevoCliente/Formulario1'
import Formulario2 from '../NuevoCliente/Formulario2'
import Formulario3 from '../NuevoCliente/Formulario3'
import ClienteContext from '../../../context/cliente/clienteContext';
import UsuarioContext from "../../../context/usuario/usuarioContext";
import {Grid} from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import Titulo from '../../Titulo'
import BotonLoading from "../../Buttons/BotonLoading"

const useStyles = makeStyles((theme) => ({
    root: {
        position: "relative",
        width: "100%",
    },
    button: {
        marginTop: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
    card:{
        padding:"20px", 
        borderRadius:"12px",
        width:"500px",
    },
}))
export default function ClienteFinal(props) {
    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const [open, setOpen]=useState(true);
    const clienteContext = useContext(ClienteContext);
    const {agregarCliente } = clienteContext;
    const usuarioContext = useContext(UsuarioContext);
    const {
        mensaje,
        obtenerUsuarios,
        agregarUsuario,
        errorUsuario,
        clearErrorUsuario,
        clearOkUsuario,
    } = usuarioContext;
    const [cliente, setCliente]=useState(" ")
return (
    <div style={{width:"1050px"}}>
        <Grid container direction="row" justify="center"  alignItems="flex-start" spacing={1}>
            <Grid item xs={6}>
                <Grid container direction="column" justify="center"  alignItems="center" spacing={1}>
                    <Grid item xs={12}>
                        <Paper elevation={3} className={classes.card}>
                            <Grid container direction="row" justify="center"  alignItems="flex-start" spacing={1}>
                                <Grid item xs={6}>
                                    <Typography component="h1" variant="h5" style={{marginBottom:"3px"}}> Cuit </Typography>
                                    <Typography variant="subtitle1" style={{marginBottom:"5px"}}>{props.cliente.cuit} </Typography>
                                    <Typography component="h1" variant="h5" style={{marginBottom:"3px"}}> Pais</Typography>
                                    <Typography variant="subtitle1" style={{marginBottom:"5px"}}>{props.cliente.nombrePais} </Typography>
                                    <Typography component="h1" variant="h5" style={{marginBottom:"3px"}}> Localidad </Typography>
                                    <Typography variant="subtitle1" style={{marginBottom:"5px"}}>{props.cliente.nombreLocalidad}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography component="h1" variant="h5" style={{marginBottom:"3px"}}> Razon Social </Typography>
                                    <Typography variant="subtitle1" style={{marginBottom:"5px"}}>{props.cliente.razonSocial} </Typography>
                                    <Typography component="h1" variant="h5" style={{marginBottom:"3px"}}> Provincia </Typography>
                                    <Typography variant="subtitle1" style={{marginBottom:"5px"}}>{props.cliente.nombreProvincia}</Typography>
                                    <Typography component="h1" variant="h5" style={{marginBottom:"3px"}}> Direccion </Typography>
                                    <Typography variant="subtitle1" style={{marginBottom:"5px"}}>{props.cliente.direccion}</Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                    <Grid item xs={12}>
                        <Paper elevation={3} className={classes.card}>
                            <Grid container direction="row" justify="center"  alignItems="center" spacing={1}>
                                <Grid item xs={6}>
                                    <Typography component="h1" variant="h5" style={{marginBottom:"3px"}}> Nombre</Typography>
                                    <Typography variant="subtitle1" style={{marginBottom:"5px"}}>{props.cliente.nombre} </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography component="h1" variant="h5" style={{marginBottom:"3px"}}> Correo Electrónico </Typography>
                                    <Typography variant="subtitle1" style={{marginBottom:"5px"}}>{props.cliente.email}</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography component="h1" variant="h5" style={{marginBottom:"3px"}}> Numero de Télefono</Typography>
                                    <Typography variant="subtitle1" style={{marginBottom:"5px"}}>{ props.codigoPais==="+549" ? "(0" + props.cliente.codigoArea +") 15"+ props.cliente.numeroTelefono : "(0" + props.cliente.codigoArea +") "+ props.cliente.numeroTelefono  } </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={6}>
                    <Grid item xs={6} md={6} lg={6}> 
                        <Paper elevation={3} className={classes.card}>
                            <Typography component="h1" variant="h5" style={{marginBottom:"3px"}}> Numeros de Contacto</Typography>
                            {props.cliente.telefono.map((t)=> <>
                                <Typography variant="subtitle1" style={{marginBottom:"5px"}}>{ t.codigoPais==="+549" ? "(0" + t.codigoArea +") 15"+ t.numeroTelefono : "(0" + t.codigoArea +") "+ t.numeroTelefono  } </Typography>
                            </>)}
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>  
                        <Grid container justify="space-around">
                            <Button onClick={props.handleBack} variant="outlined" color="primary" className={classes.button}  style={{color:"#0B3845"}}>
                                Volver
                            </Button>
                            <BotonLoading texto={"Cargar Otro"} disabled={false} load={props.alerta} onClick={props.otro}/>
                            <BotonLoading texto={"Finalizar"} disabled={false} load={props.alerta} onClick={props.finalizar}/> 
                        </Grid>
                    </Grid>
            </Grid>
        </Grid>
    </div>
    )
}
